/** @jsx jsx */
import { useStaticQuery, graphql } from "gatsby"
import { jsx, Box } from "theme-ui"
import Img from "gatsby-image"

const Prado = () => {
  const data = useStaticQuery(graphql`
    query prado {
      file(relativePath: { eq: "prado.jpeg" }) {
        childImageSharp {
          # Specify the image processing specifications right in the query.
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Box>
      <Img
        sx={{ my: 5, maxWidth: "40em" }}
        fluid={data.file.childImageSharp.fluid}
      />
    </Box>
  )
}

export default Prado
